<script>

import Swal from "sweetalert2";
import moment from "moment/moment";

export default {
  setup() {
    return { };
  },
  components: {

  },
  props: {
    produtosList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    updating: {
      type: Boolean,
    },
  },
  mounted() {
    // console.log('mounted produtos-table_0')
    // console.log(this.updating)
  },
  methods: {

    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Ativo'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },

    detalhes(idData){
      console.log('detalhes_0: ' + idData)
      this.$router.push(`/produto/detalhe/${idData}`);

    },

    editar(idData){
      const routeData = this.$router.resolve(`/produto/editar/${idData}`)
      window.open(routeData.href, '_blank')
    },

    deletar(idData){
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.$emit('deletareg', idData)
        }
      })
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

  },
  data() {
    return {
      regSelecionado: {},

    };
  },
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table align-middle table-nowrap">
      <thead class="table-light">
      <tr>

        <th class="align-middle">ID</th>
        <th class="align-middle text-end">Palete</th>
        <th class="align-middle text-end">Endereço</th>


        <th class="align-middle">Código</th>
        <th class="align-middle">Descrição</th>

        <th class="align-middle text-end">Lote</th>
        <th class="align-middle text-end">Validade</th>

        <th class="align-middle">Unidade</th>
        <th class="align-middle">Status</th>
        <th class="align-middle text-end">Pr.Base</th>
        <th class="align-middle text-end">Saldo</th>


        <th class="align-middle">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in produtosList" :key="data.id">

        <td>
          <a href="javascript: void(0);" class="text-body fw-bold" @click="editar(data.id)">
            #{{ data.id }}
          </a>
        </td>

        <td class="text-end">{{ data.palete }} </td>
        <td class="text-end">{{ data.endwms }} </td>


        <td>
          <a href="javascript: void(0);" class="text-body fw-bold" @click="editar(data.id)">
            #{{ data.codigo }}
          </a>
        </td>

        <td>{{ data.descricao }} </td>

        <td class="text-end">{{ data.lote }} </td>
        <td class="text-end">{{data.dtvalid_fmt  }} </td>

        <td>{{ data.unidade }} </td>
        <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="data.status === 'A' ? 'badge-soft-success' : 'badge-soft-danger'">
                {{ nomeStatus(data.status)  }}
              </span>
        </td>

        <td class="text-end">{{ formatDecimal(data.preco) }} </td>
        <td class="text-end">{{ formatDecimal(data.saldo) }} </td>


        <td>
          <div class="button-items">

<!--            <b-button variant="outline-success" @click="detalhes(data.id)">-->
<!--              <i class="mdi mdi-eye d-block font-size-16"></i>-->
<!--            </b-button>-->

            <b-button variant="outline-warning" @click="editar(data.id)" :disabled="data.email === 'admin@admin.com.br'">
              <i class="mdi mdi-pencil d-block font-size-16"></i>
            </b-button>

<!--            <b-button variant="outline-danger" @click="deletar(data.id)" :disabled="data.email === 'admin@admin.com.br'">-->
<!--              <i class="mdi mdi-trash-can d-block font-size-16"></i>-->
<!--            </b-button>-->

          </div>
        </td>


      </tr>
      </tbody>
    </table>


  </div>

</template>
